module.exports = __webpack_public_path__ + "static/media/tti_portfolio@3x.403dc95e.png";